import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithMiddlewares } from "appRedux/baseQuery"
import {
  updateForgetPasswordResult,
  updateForgetPasswordStep,
  updateShowPasswordChangedSuccessfullyModal
} from "appRedux/slices/resetPasswordSlice"
import { handleOnLoginQueryStarted, handleOnLogOutQueryStarted, handleOnRegisterQueryStarted } from "appRedux/helpers/authApiHelpers"

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithMiddlewares("/auth"),
  endpoints: (builder) => ({
    register: builder.mutation<void, registerRequestPayload>({
      query: (body) => ({
        url: "/register",
        method: "POST",
        body: body
      }),
      onQueryStarted: handleOnRegisterQueryStarted
    }),
    login: builder.mutation<void, loginRequestPayload>({
      query: (body) => ({
        url: "/login",
        method: "POST",
        body: body
      }),
      onQueryStarted: handleOnLoginQueryStarted
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: "/logout",
        method: "POST"
      }),
      onQueryStarted: handleOnLogOutQueryStarted
    }),
    forgetPassword: builder.mutation<ForgetPasswordResponseDto, string>({
      query: (email) => ({
        url: `/forgot-password?email=${email}`,
        method: "POST"
      }),
      onQueryStarted: async (body, { dispatch, queryFulfilled, getState }) => {
        try {
          const { data } = await queryFulfilled
          dispatch(updateForgetPasswordResult(data))
          dispatch(updateForgetPasswordStep(2))
        } catch (error) {
          console.log(error)
        }
      }
    }),
    resetPassword: builder.mutation<void, ResetPasswordRequestPayload>({
      query: (body) => ({
        url: "/reset-password",
        method: "POST",
        body: body
      }),
      onQueryStarted: async (body, { dispatch, queryFulfilled, getState }) => {
        try {
          await queryFulfilled
          dispatch(updateShowPasswordChangedSuccessfullyModal())
        } catch (error) {
          console.log(error)
          // dispatch(updateShowPasswordChangedSuccessfullyModal())
        }
      }
    }),
    changePassword: builder.mutation<void, ChangePasswordRequestPayload>({
      query: (body) => ({
        url: "/change-password",
        method: "POST",
        body: body
      }),
      onQueryStarted: async (body, { dispatch, queryFulfilled, getState }) => {
        try {
          await queryFulfilled
          dispatch(updateShowPasswordChangedSuccessfullyModal())
        } catch (error) {
          console.log(error)
        }
      }
    })
  })
})

export const {
  useRegisterMutation,
  useLoginMutation,
  useLogoutMutation,
  useForgetPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation
} = authApi
